// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isEmpty = (obj?: Record<string, any> | '' | null) => obj === undefined || obj === null || obj === '' || (typeof obj === 'object' && Object.keys(obj).length === 0);
